'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPartnershipDetailComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerPartnershipDetailComponent = exports.sellerPartnershipDetailComponent = {
    template: require('./partnership-detail.html'),
    bindings: {
        seller: '<',
        partnership: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "$state", "common", "gettextCatalog", "Analytics", "partnershipsService", function sellerPartnershipDetailController($rootScope, $state, common, gettextCatalog, Analytics, partnershipsService) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$onChanges = bindingChanges;
        vm.context = 'partnership';
        vm.checkYearsApart = checkYearsApart;
        vm.moment = _moment2.default;

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            vm.gallerySliderSettings = partnershipsService.getGallerySliderSettings();
            common.setTitle(gettextCatalog.getString(vm.partnership.title));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/partnerships/' + vm.partnership.id, vm.partnership.title);
        }

        function checkYearsApart(contract) {
            return (0, _moment2.default)(contract.endDate).format('YYYY') - (0, _moment2.default)(contract.startDate).format('YYYY') > 10 ? true : false;
        }

        function bindingChanges(changes) {
            if (changes.partnership) {
                if (changes.partnership.currentValue) {
                    vm.partnership = Object.assign(changes.partnership.currentValue, {
                        summary: (0, _marked2.default)(changes.partnership.currentValue.summary || ''),
                        content: (0, _marked2.default)(changes.partnership.currentValue.content || ''),
                        callToActionContent: (0, _marked2.default)(changes.partnership.currentValue.callToActionContent || '')
                    });
                } else {
                    vm.partnership = changes.partnership.currentValue;
                }
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/partnership-detail.js
// module id = 1024
// module chunks = 0